module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("lG4Kl"))).then(() => parcelRequire('cvs7o'));